import { DefaultTheme } from 'styled-components';

const whites: DefaultTheme['colorDefinitions']['whites'] = {
  white1: '#ffffff',
};

const grays: DefaultTheme['colorDefinitions']['grays'] = {
  gray0: '#979797',
  gray1: '#5E5E5E',
  gray2: '#8B8B8B',
  gray3: '#A1A5B4',
  gray4: '#B2B2B2',
  gray5: '#C4C6CB',
  gray6: '#D0D1D3',
  gray7: '#E6E7EB',
  gray8: '#F1F2F5',
  gray9: '#F8F8FA',
  gray10: '#FAFAFB',
  gray11: '#AEB2BF',
  gray12: '#EFF0F3',
  gray13: '#F7F7F9',
};

const blacks: DefaultTheme['colorDefinitions']['blacks'] = {
  black0: '#010101',
  black1: '#161618',
  black2: '#212123',
  black3: '#32343c',
  black4: '#3B3D42',
  black5: '#606679',
  black6: '#000000',
  black7: '#2C2C2F',
  black8: '#4E515F',
  black9: '#1E1E21',
};

const reds: DefaultTheme['colorDefinitions']['reds'] = {
  red0: '#fbd6d7',
  red1: '#E51F37',
  red2: '#F4514D',
  red3: '#ed0a0f',
  red4: '#F6E7E8',
  red5: '#8B4241',
  red6: '#FBDADE',
};

const blues: DefaultTheme['colorDefinitions']['blues'] = {
  blue0: '#ECF4FD',
  blue1: '#086EE5',
  blue2: '#085DC0',
};
const purples: DefaultTheme['colorDefinitions']['purples'] = {
  purple1: '#9777FF',
};

const greens: DefaultTheme['colorDefinitions']['greens'] = {
  green0: '#EBFEF9',
  green1: '#d7e8c9',
  green2: '#a2d76b',
  green3: '#8ccc48',
  green4: '#4D5E3A',
  green5: '#7dc137',
  green6: '#74C71F',
  green7: '#068c63',
};

const oranges: DefaultTheme['colorDefinitions']['oranges'] = {
  orange1: '#f7b500',
};

const hints: DefaultTheme['colorDefinitions']['hints'] = {
  hint1: '#EFD07D',
  hint2: '#34363F',
  hint3: '#3E4339',
  hint4: '#ae9558',
  hint5: '#F2D892',
  hint6: '#53400D',
  hint7: '#F3DA93',
};

const socialMedia: DefaultTheme['colorDefinitions']['socialMedia'] = {
  facebook: '#3B5998',
  twitter: '#1DA1F2',
  google: '#4285F4',
  apple: '#000000',
};

const cards: DefaultTheme['colorDefinitions']['cards'] = {
  visa: '#172274',
  mastercard: '#F79E1B',
  amex: '#2671B9',
  diners: '#002554',
  discover: '#ec6b29',
  jcb: '#008eed',
  unionpay: '#dd2c34',
};

const colorDefinitions = {
  whites,
  grays,
  blacks,
  reds,
  greens,
  oranges,
  hints,
  socialMedia,
  cards,
  blues,
  purples,
};

export default colorDefinitions;
